<template>
<div class="chapter">
<div class="inner_page">
<table class="chapter-title-corner-decorations" width="100%"><tbody><tr><td class="chapter-title-corner-decoration-left-column"><div class="chapter-title-corner-decoration-left-column"><img alt="image" class="chapter-title-corner-decoration-left" src="d2d_images/chapter_title_corner_decoration_left.png"/></div></td><td class="chapter-title-corner-decoration-middle-column"> </td><td class="chapter-title-corner-decoration-right-column"><div class="chapter-title-corner-decoration-right-column"><img alt="image" class="chapter-title-corner-decoration-right" src="d2d_images/chapter_title_corner_decoration_right.png"/></div></td></tr></tbody></table><div class="chapter-title"><div class="chapter-title-decoration-above"><div class="chapter-title-decoration-above-inner"><img alt="image" class="chapter-title-decoration-above" src="d2d_images/chapter_title_above.png"/></div></div><h1 class="chapter-title">Il Conte e la Semplice Jane</h1>
<h1>(I Signori di Eton, Libro 2)</h1>
<h1>Di</h1>
<h1>Cheryl Bolen</h1>
<div class="chapter-title-decoration-below"><div class="chapter-title-decoration-below-inner"><img alt="image" class="chapter-title-decoration-below" src="d2d_images/chapter_title_below.png"/></div></div></div><p style="page-break-before: always; text-align: center; text-indent: 0">Copyright © 2018 di Cheryl Bolen</p>
<p class="first-in-chapter" style="text-align: justify"><span style="font-style: italic"><span class="first-chapter-phrase"><span class="drop-cap">I</span>l Conte, la Promessa</span>, e la Ragazza Comune</span> è un’opera di fantasia. Nomi, personaggi, posti, ed avvenimenti sono frutto dell’immaginazione dell’autrice o sono usati in maniera fittizia. Qualsiasi somiglianza con eventi reali, locali, o persone, vive o morte, è del tutto casuale.</p>
<p style="text-align: center; text-indent: 0">Tutti i diritti sono riservati.</p>
<p style="text-align: justify">Nessuna parte di questa pubblicazione può essere riprodotta, immagazzinata o trasmessa in qualsiasi forma o con qualsiasi mezzo senza l’autorizzazione preventiva dell’autore.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c004.vue?0807bcc6